import { BASE_URL } from "../lib/api";

export const BRANDS = {
  DYMAX_TECH: "DymaxTech",
  E360_DIGITAL: "e360Digital",
  LOGO_GUTS: "LogoGuts",
  MULTIVERSE_SOL: "MultiverseSol",
} as const;

export type BrandType = typeof BRANDS[keyof typeof BRANDS];

export interface BrandConfig {
  name: BrandType;
  logo: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  typography: {
    headingFont: string;
    bodyFont: string;
  };
  upworkProfile: string;
  defaultSections: string[];
}

const getLogoUrl = (filename: string) => {
  return `${BASE_URL}brands/${filename}`;
};

export const BRAND_CONFIGS: Record<BrandType, BrandConfig> = {
  [BRANDS.DYMAX_TECH]: {
    name: BRANDS.DYMAX_TECH,
    logo: getLogoUrl("dymax-logo.png"),
    primaryColor: "#1e3a8a",
    secondaryColor: "#3b82f6",
    accentColor: "#60a5fa",
    typography: {
      headingFont: "Inter",
      bodyFont: "Inter",
    },
    upworkProfile: "https://www.upwork.com/freelancers/dymaxtech",
    defaultSections: ["intro", "choose", "problem", "solution", "offer", "reviews", "conclusion"],
  },
  [BRANDS.E360_DIGITAL]: {
    name: BRANDS.E360_DIGITAL,
    logo: getLogoUrl("e360-logo.png"),
    primaryColor: "#2462b2",
    secondaryColor: "#1e55a0",
    accentColor: "#3b7dd6",
    typography: {
      headingFont: "Poppins",
      bodyFont: "Inter",
    },
    upworkProfile: "https://www.upwork.com/freelancers/e360digital",
    defaultSections: ["intro", "choose", "problem", "solution", "offer", "pastJobs", "conclusion"],
  },
  [BRANDS.LOGO_GUTS]: {
    name: BRANDS.LOGO_GUTS,
    logo: getLogoUrl("logoguts-logo.png"),
    primaryColor: "#7c3aed",
    secondaryColor: "#8b5cf6",
    accentColor: "#a78bfa",
    typography: {
      headingFont: "Montserrat",
      bodyFont: "Open Sans",
    },
    upworkProfile: "https://www.upwork.com/freelancers/logoguts",
    defaultSections: ["intro", "choose", "solution", "offer", "reviews", "conclusion"],
  },
  [BRANDS.MULTIVERSE_SOL]: {
    name: BRANDS.MULTIVERSE_SOL,
    logo: getLogoUrl("multiverse-logo.png"),
    primaryColor: "#059669",
    secondaryColor: "#10b981",
    accentColor: "#34d399",
    typography: {
      headingFont: "Raleway",
      bodyFont: "Lato",
    },
    upworkProfile: "https://www.upwork.com/freelancers/multiversesol",
    defaultSections: ["intro", "choose", "problem", "solution", "projectScores", "offer", "conclusion"],
  },
};

export const AVAILABLE_SECTIONS = [
  { id: "intro", label: "Introduction", order: 0 },
  { id: "choose", label: "Why Choose Us", order: 1 },
  { id: "problem", label: "Client Problem", order: 2 },
  { id: "solution", label: "Our Solution", order: 3 },
  { id: "reviews", label: "Reviews / Testimonials", order: 4 },
  { id: "pastJobs", label: "Past Success Jobs", order: 5 },
  { id: "projectScores", label: "Project Scores / Ratings", order: 6 },
  { id: "offer", label: "Our Offer", order: 7 },
  { id: "conclusion", label: "Conclusion", order: 8 },
] as const;
